import { assign, setup } from "xstate";

type SystemEvent =
  | { type: "CONNECTIVITY_CHANGE"; status: "online" | "offline" | "checking" }
  | {
      type: "AUTH_CHANGE";
      status: "authenticated" | "unauthenticated" | "guest";
    }
  | { type: "BOOT_COMPLETE" };

interface SystemContext {
  connectivity: "online" | "offline" | "checking";
  auth: "authenticated" | "unauthenticated" | "guest";
  isBooted: boolean;
}

export const systemMachine = setup({
  // Schema Definition Pattern for XState v5 type inference
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  types: {} as {
    context: SystemContext;
    events: SystemEvent;
  },
}).createMachine({
  id: "system",
  initial: "booting",
  context: {
    connectivity: "checking",
    auth: "unauthenticated",
    isBooted: false,
  },
  states: {
    booting: {
      on: {
        BOOT_COMPLETE: {
          target: "active",
          actions: assign({ isBooted: true }),
        },
      },
    },
    active: {
      on: {
        CONNECTIVITY_CHANGE: {
          actions: assign({ connectivity: ({ event }) => event.status }),
        },
        AUTH_CHANGE: {
          actions: assign({ auth: ({ event }) => event.status }),
        },
      },
    },
  },
});
